export const environment = {
  production: true,
  userBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  /**
   * Centralized auth-ui login URL — used by validate-token when no session exists.
   * Includes returnTo so auth-ui redirects back to our SSO callback after login.
   *
   * URL de connexion auth-ui centralisé — utilisé par validate-token si aucune session.
   * Inclut returnTo pour que auth-ui redirige vers notre callback SSO après la connexion.
   */
  userMgtUrl: 'https://auth.stage.tsin.ca/login?returnTo=https://learning.stage.tsin.ca/auth/callback',
  /** Auth-UI public base URL (used for retry redirects / URL publique auth-ui pour les nouvelles tentatives) */
  authUiUrl: 'https://auth.stage.tsin.ca',
  /** Auth backend base URL for Cognito token exchange (URL de base du backend auth pour l'échange de jeton Cognito) */
  authServiceUrl: 'https://auth.api.stage.tsin.ca',
  paymentUrl: 'https://payment-dev.tsin.ca',
  learningBaseUrl: 'https://learning.api.stage.tsin.ca/api',
  authBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  oldApiUrl: 'https://portalstage-be.tsin.ca/api/',
  recaptchaSiteKey: '6LeGUecqAAAAAG7TT48TUcRNZTvZn7bTlZC9W5FP',
  jiraLink: 'https://tsin.atlassian.net/servicedesk/customer/portal/8'
};
